import React, { useRef } from 'react'
import Button from './Button';
import { Link } from "react-scroll";

export default function Navbar() {

    const mainMenu = useRef(null)
    const openMainMenu = () => {
        mainMenu.current.classList.toggle('hidden');
    }


    return (
        <>
            <nav className="bg-white dark:bg-gray-900 sticky top-0 w-full z-20 start-0 border-b border-gray-200 dark:border-gray-600" id='navbar'>
                <div className="max-w-screen-xl flex flex-wrap items-center justify-between mx-auto p-4">
                    <a href="https://flowbite.com/" className="flex items-center space-x-3 rtl:space-x-reverse">
                        {/* <img src="https://flowbite.com/docs/images/logo.svg" className="h-8" alt="Flowbite Logo"> */}
                        <span className="self-center text-2xl font-semibold whitespace-nowrap dark:text-white"><b>Simplify</b></span>
                    </a>
                    <div className="flex md:order-2 space-x-3 md:space-x-0 rtl:space-x-reverse">
                        <Button text="Get Started" />
                        <button data-collapse-toggle="navbar-sticky" onClick={openMainMenu} type="button" className="inline-flex items-center p-2 w-10 h-10 justify-center text-sm text-gray-500 rounded-lg md:hidden hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200 dark:text-gray-400 dark:hover:bg-gray-700 dark:focus:ring-gray-600" aria-controls="navbar-sticky" aria-expanded="false">
                            <span className="sr-only">Open main menu</span>
                            <svg className="w-5 h-5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 17 14">
                                <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M1 1h15M1 7h15M1 13h15" />
                            </svg>
                        </button>
                    </div>
                    <div className="items-center justify-between hidden w-full md:flex md:w-auto md:order-1" ref={mainMenu} >
                        <ul className="flex flex-col p-4 md:p-0 mt-4 font-medium border border-gray-100 rounded-lg bg-gray-50 md:space-x-8 rtl:space-x-reverse md:flex-row md:mt-0 md:border-0 md:bg-white dark:bg-gray-800 md:dark:bg-gray-900 dark:border-gray-700">
                            <li>
                                <Link
                                to="top"
                                activeClass='bg-blue-700 md:text-blue-700'
                                    spy={true}
                                    smooth={true}
                                    offset={-70}
                                    duration={500} 
                                    className="cursor-pointer block py-2 px-3  rounded md:bg-transparent text-gray-900 md:p-0 md:hover:bg-transparent md:hover:text-blue-700 " aria-current="page">Home</Link>
                            </li>
                            <li>
                                <Link to="our_services"
                                activeClass='bg-blue-700 md:text-blue-700'
                                    spy={true}
                                    smooth={true}
                                    offset={-70}
                                    duration={500} 
                                    className="cursor-pointer block py-2 px-3 text-gray-900 rounded hover:bg-gray-100 md:bg-transparent  md:hover:bg-transparent md:hover:text-blue-700 md:p-0">Services</Link>
                            </li>
                            <li>
                                <Link to="why-us"
                                activeClass='bg-blue-700 md:text-blue-700'
                                spy={true}
                                smooth={true}
                                offset={-70}
                                duration={500} 
                                className="cursor-pointer block py-2 px-3  rounded md:bg-transparent text-gray-900 md:p-0 md:hover:bg-transparent md:hover:text-blue-700 " >Why-Us</Link>
                            </li>
                            <li>
                                <Link 
                                to="work_sample"
                                activeClass='bg-blue-700 md:text-blue-700'
                                spy={true}
                                smooth={true}
                                offset={-70}
                                duration={500} 
                                className="cursor-pointer block py-2 px-3  rounded md:bg-transparent text-gray-900 md:p-0 md:hover:bg-transparent md:hover:text-blue-700 " >Samples</Link>
                            </li>
                        </ul>
                    </div>
                </div>
            </nav>

        </>
    )
}
